import React from 'react';
import './BrandLogo.css';

const BrandLogo = ({ className = '', compact = false, light = false }) => (
  <div className={`sv-brand-logo ${compact ? 'compact' : ''} ${light ? 'light' : ''} ${className}`.trim()}>
    <img src="/brand/sao-viet-logo.png" alt="Trung tâm Tin học Sao Việt" />
  </div>
);

export default BrandLogo;
